import React, { PropTypes } from 'react';
import { Link } from 'react-router';


const propTypes = {
  locale: PropTypes.string,
  media: PropTypes.object.isRequired,
};

const MediaPartner = ({ locale, media }) => {
  const { id, name, image } = media;
  const src = `https://admin.futurecom.com.br/uploads/media_partner/${image}`;

  const link = `${locale}/media-partners/${id}`;

  return (
    <li className="sponsor">
      <Link to={link}>
        <img src={src} alt={name} />
      </Link>
    </li>
  );
};

MediaPartner.propTypes = propTypes;

export default MediaPartner;



/** WEBPACK FOOTER **
 ** ./src/components/screens/mediaPartners/MediaPartner.js
 **/